import {Home, Circle, User, Tag, ShoppingCart, Search, LogOut, File, Upload, Briefcase } from 'react-feather'
import icons from '../../assets/images/icons/icons'

export default [ 
  {
    id: 'home',
    title: <h1 className='menuItens'>Pagina Inicial</h1>,
    icon: <Home className='menuIcon' size={20} />,
    navLink: '/home',
    disabled:true
  },
  {
    id: 'user',
    title: <h1 className='menuItens'>Perfil</h1>,
    icon: <User className='menuIcon' size={20} />,
    navLink:"/perfil",
    disabled:true
  },
  {
    id: 'empresas',
    title: <h1 className='menuItens'>Empresas</h1>,
    icon: <Briefcase className='menuIcon' size={20} />,
    navLink:"/empresas",
    disabled:true
  },
  {
    id: 'XML',
    title: <h1 className='menuItens'>Documentos fiscais</h1>,
    icon: <File className='menuIcon' size={20} />,
    navLink:"/documentos-fiscais",
    disabled:true
  },
  {
    id: 'Calculo',
    title:  <h1 className='menuItens'>Calculadora</h1>,
    icon: icons[0].icon,
    children: [
      {
        id: 'ICMS-ST',
        title: 'ICMS-ST',
        icon: <Circle size={12} />,
        navLink:'/calculadora/icmsst',
        disabled:true
      },
      {
        id: 'DIFAL',
        title: 'DIFAL',
        icon: <Circle size={12} />,
        navLink: '/calculadora/difal',
        disabled:true
      }
    ]
  },
  {
    id: 'guias',
    title: <h1 className='menuItens'>Guias de pagamentos</h1>,
    icon: <Tag className='menuIcon' size={20} />,
    navLink: '/guias',
    disabled:true
  },
  {
    id:"Simulador",
    title:<h1 className='menuItens'>Simulador</h1>,
    icon:<ShoppingCart className='menuIcon' size={20}/>,
    navLink:"/simulador",
    disabled:true
  },
  {
    id:'Consultas',
    title:<h1 className='menuItens'>Consultas</h1>,
    icon:<Search className='menuIcon' size={20} />,
    disabled:true
  }
]
